import './MainPageSub04_0.scss';

import React, { useEffect } from 'react';
import MainPageSub04_1 from './MainPageSub04_1'
import MainPageSub04_2 from './MainPageSub04_2'
import MainPageSub04_3 from './MainPageSub04_3'

const MainPageSub04_0 = () => {


    //====================================================================
    return (
        <div className="MainPageSub04_0">

            <section className='sec-main'>
                <p className="heading-1 title1">
                    04 <span className="i-custom">학습과 공부를 끌다</span>
                </p>
            </section>

            <section className="sec-child">

                <div data-aos="fade-up" data-aos-delay="200">
                    <MainPageSub04_1 />
                </div>

    
                <div data-aos="zoom-in" data-aos-delay="600">
                    <MainPageSub04_2 />
                </div>

  
                <div data-aos="fade-up" data-aos-delay="1000">
                    <MainPageSub04_3 />
                </div>

            </section>



        </div>
    );
};

export default MainPageSub04_0;
